export function convertZoomLevel(zoom: number) {
  return zoom - 1;
}
